export default "__VITE_ASSET__bL9gRb9y__"